import { PropsWithChildren, Suspense } from "react";

import { Outlet } from "react-router-dom";

import { layoutStyles as styles } from "../Layout.styles";
import { useLayoutContext } from "../context";

export const MainContent = ({ children }: PropsWithChildren) => {
  const { blur } = useLayoutContext();

  return (
    <main css={styles.contentContainer({ blur })}>
      {children ? (
        children
      ) : (
        <Suspense>
          <Outlet />
        </Suspense>
      )}
    </main>
  );
};
